module.exports = __webpack_public_path__ + "img/DSC_0042-1.cc966763.jpeg";